import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import { fetchUserData, logoutUser } from "../actions/userActions";
import AdminDashboard from "../pages/AdminDashboard";
import AdminLectures from "../pages/AdminLectures";
import AdminProjectsDashboard from "../pages/AdminProjectsDashboard";
import Assignments from "../pages/Assignments";
import Dashboard from "../pages/Dashboard";
import Instructors from "../pages/Instructors";
import Lectures from "../pages/Lectures";
import MyCourse from "../pages/MyCourse";
import Profile from "../pages/Profile";
import Projects from "../pages/Projects";
import StudentProgress from "../pages/StudentProgress";
import TicketsModule from "../pages/TicketsModule";
import Utils from "../utils/utils";
import AdminPrivateRoute from "./AdminPrivateRoute";
import AssignmentDashboard from "./Assignments/AssignmentDashboard";
import AssignmentViewStudent from "./Assignments/AssignmentViewStudent";
import CodeEditor from "./CodeEditor/CodeEditor";
import PrivateRoute from "./PrivateRoute";
import Sidebar from "./Sidebar";
import { useToast } from "./ToastContext";
import Upperbar from "./Upperbar";
const Home = () => {
  const token = Utils.getToken();
  const [clickedLink, setClickedLink] = useState("lectures");
  const [heading, setHeading] = useState("Dashboard");
  const { isLoaded, user, loading, error, status } = useSelector(
    (state) => state.user
  );

  const dispatch = useDispatch();
  const [role, setRole] = useState(null);
  const showToast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 403) {
      showToast("Unauthorized. Kindly login.", "error", true, 3000);
      Utils.logOut();
      dispatch(logoutUser());
      navigate("/signin");
    }
  }, [status, navigate, dispatch]);

  // useEffect(() => {
  //   // let user = Utils.getLoggedInUser();
  //   let role = Utils.UserRole;
  //   setRole(role);
  // }, []);

  useEffect(() => {
    if (!Utils.getToken()) {
      navigate("/signin");
    }
  }, []);

  useEffect(() => {
    const role = Utils.UserRole;
    setRole(role);
    if (
      (user && user.role === "student" && user.accountStatus === 2) ||
      (user && user.role === "admin" && user.status === 2)
    ) {
      navigate("/unauth");
      setTimeout(() => {
        Utils.logOut();
        dispatch(logoutUser());
      }, 1000);
      return;
    }

    if (!isLoaded) {
      dispatch(fetchUserData());
    }
  }, [dispatch, isLoaded]);

  const handleLinkClick = (link) => {
    setClickedLink(link);
  };

  if (status === 401) navigate("/signin");
  return (
    <PrivateRoute token={token}>
      <div className="drawer w-[100%] lg:drawer-open overflow-hidden scrollbar-none">
        <input id="my-drawer-2" type="checkbox" className="drawer-toggle" />

        <div className="drawer-content flex flex-col h-[100%] overflow-y-auto items-center justify-center ">
          {user && (
            <Upperbar
              user={user}
              token={token}
              role={role}
              tab={heading}
              setHeading={setHeading}
            />
          )}

          <div className="w-full scrollbar-thin scrollbar-track-slate-100">
            <Routes>
              <Route
                path="/"
                element={
                  <PrivateRoute token={token}>
                    <Dashboard />
                  </PrivateRoute>
                }
              />

              <Route
                path="admin-dashboard"
                element={
                  <AdminPrivateRoute token={token} role={role}>
                    <AdminDashboard />
                  </AdminPrivateRoute>
                }
              />

              <Route
                path="lectures"
                element={
                  <PrivateRoute token={token}>
                    <Lectures />
                  </PrivateRoute>
                }
              />

              <Route
                path="course"
                element={
                  <PrivateRoute token={token}>
                    <MyCourse clickedLink={clickedLink} />
                  </PrivateRoute>
                }
              />

              <Route
                path="assignments/view/:id"
                element={
                  <PrivateRoute token={token}>
                    <AssignmentViewStudent />
                  </PrivateRoute>
                }
              />

              {Utils.UserRole && Utils.UserRole.toLowerCase() === "admin" ? (
                <Route
                  path="assignments"
                  element={
                    <AdminPrivateRoute role={role} token={token}>
                      <Assignments user={user} />
                    </AdminPrivateRoute>
                  }
                />
              ) : (
                <Route
                  path="assignments"
                  element={
                    <PrivateRoute token={token}>
                      <AssignmentDashboard user={user} />
                    </PrivateRoute>
                  }
                />
              )}

              <Route
                path="profile"
                element={
                  <PrivateRoute token={token}>
                    <Profile />
                  </PrivateRoute>
                }
              />

              <Route
                path="support"
                element={
                  <PrivateRoute token={token}>
                    <TicketsModule />
                  </PrivateRoute>
                }
              />

              <Route
                path="all-lectures"
                element={
                  <AdminPrivateRoute token={token} role={role}>
                    <AdminLectures />
                  </AdminPrivateRoute>
                }
              />

              <Route
                path="instructors"
                element={
                  <AdminPrivateRoute token={token} role={role}>
                    <Instructors />
                  </AdminPrivateRoute>
                }
              />

              {Utils.UserRole && Utils.UserRole.toLowerCase() === "admin" ? (
                <Route
                  path="projects"
                  element={
                    <AdminPrivateRoute role={role} token={token}>
                      <AdminProjectsDashboard user={user} />
                    </AdminPrivateRoute>
                  }
                />
              ) : (
                <Route
                  path="projects"
                  element={
                    <PrivateRoute token={token}>
                      <Projects user={user} />
                    </PrivateRoute>
                  }
                />
              )}
              <Route
                path="student-progress"
                element={
                  <AdminPrivateRoute role={role} token={token}>
                    <StudentProgress user={user} token={token} />
                  </AdminPrivateRoute>
                }
              />
              <Route
                path="compiler"
                element={
                  <PrivateRoute token={token}>
                    <CodeEditor user={user} />
                  </PrivateRoute>
                }
              />
            </Routes>
          </div>
        </div>

        <div className="drawer-side z-20 h-full">
          <label
            htmlFor="my-drawer-2"
            aria-label="close sidebar"
            className="drawer-overlay"
          ></label>

          <ul
            className="menu h-full w-72 overflow-y-auto"
            style={{ maxHeight: "100vh", padding: "0px" }}
          >
            <Sidebar
              onLinkClick={handleLinkClick}
              user={user}
              token={token}
              role={role}
              setHeading={setHeading}
              heading={heading}
            />
          </ul>
        </div>
      </div>
    </PrivateRoute>
  );
};

export default Home;
